import { counsellorConstants } from '../constants';
import { appointmentConstants } from '../constants';

export function counsellorStatus(state = {}, action) {
	switch (action.type) {
		case counsellorConstants.GET_COUNSELLOR_STATUS_SUCCESS:
			return {
				...state,
				counsellorStatus: action.counsellorStatus,
			};
		case appointmentConstants.SET_COUNSELLOR_STATUS_SUCCESS:
			const data = action.data.map((item) => {
				return { project_id: item.project_id, status: item.is_available };
			});
			return {
				...state,
				counsellorStatus: data,
			};

    case counsellorConstants.GET_COUNSELLOR_STATUS_REQUEST:
      return {
        ...state,
        counsellorStatus: action.counsellorStatus,
      };
    case counsellorConstants.GET_COUNSELLOR_STATUS_FAILURE:
      return {
        ...state,
        counsellorStatus: action.counsellorStatus,
      };
    case counsellorConstants.GET_COUNSELLOR_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case counsellorConstants.GET_COUNSELLOR_DETAILS_SUCCESS:
      return {
        ...state,
        counsellorDetails: action.counsellorDetails,
        loading: false,
      };
    case counsellorConstants.GET_COUNSELLOR_DETAILS_FAILURE:
      return {
        ...state,
        counsellorStatus: action.counsellorDetails,
        loading: false,
      };
    case counsellorConstants.GET_COUNSELLOR_PROFILE_SUCCESS:
      return {
        ...state,
        counsellorProfile: action.counsellorProfile,
      };
    case counsellorConstants.GET_COUNSELLOR_PROFILE_REQUEST:
      return {
        ...state,
        counsellorProfile: null,
      };
    case counsellorConstants.GET_COUNSELLOR_PROFILE_FAILURE:
      return {
        ...state,
        counsellorProfile: null,
      };
    case counsellorConstants.GET_MULTI_COUNSELLOR_SUCCESS:
      return {
        ...state,
        multiCounsellor: action.multiCounsellor,
      };
    case counsellorConstants.GET_MULTI_COUNSELLOR_REQUEST:
      return {
        ...state,
        multiCounsellor: null,
      };
    case counsellorConstants.GET_MULTI_COUNSELLOR_FAILURE:
      return {
        ...state,
        multiCounsellor: null,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/counsellor.reducer.js